import { apiInterfaceForJson } from "../common/apiManager";

export const fetchLogs = () => {
    return apiInterfaceForJson("/log/v1/", "GET");
};

export const fetchAvailableLogs = () => {
    return apiInterfaceForJson("/log/v1/available", "GET");
};

export const searchLogs = (query) => {
    return apiInterfaceForJson("/log/v1/search", "POST", query);
};

export const fetchExportAudit = (params = {}) => {
    const qs = new URLSearchParams();
    if (params.page) qs.append("page", params.page);
    if (params.limit) qs.append("limit", params.limit);
    if (params.staffId) qs.append("staffId", params.staffId);
    if (params.from) qs.append("from", params.from);
    if (params.to) qs.append("to", params.to);
    if (params.success !== undefined && params.success !== "") qs.append("success", params.success);
    const suffix = qs.toString() ? `?${qs.toString()}` : "";
    return apiInterfaceForJson(`/log/v1/exports${suffix}`, "GET");
};

export const getLogDataById = (logId) => {
    return apiInterfaceForJson("/log/v1/" + logId, "GET");
};

export const createLog = (logDetails) => {
    return apiInterfaceForJson("/log/v1/", "POST", logDetails);
};

export const updateLog = (logDetails) => {
    return apiInterfaceForJson("/log/v1/", "PUT", logDetails);
};

export const updateLogBackgroundThemeColor = (logDetails) => {
    return apiInterfaceForJson("/log/v1/update", "POST", logDetails);
};

export const updateDevice = (deviceDetails) => {
    let logDeviceInfo = {
        _id: deviceDetails.id,
        device_id: deviceDetails.deviceId
    };
    return apiInterfaceForJson("/log/v1/updateDevice", "POST", logDeviceInfo);
};

export const deleteLog = (logDetails) => {
    return apiInterfaceForJson("/log/v1/delete", "POST", logDetails);
};
